import React, { Fragment, useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import Header from "../subheader/Header";
import { Link, useLocation } from "react-router-dom";
import "./menu.scss";

const MenuItems = (props) => {
  const [menu_items, setMenuItems] = useState([]);
  let message = "";

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Menu";

    apiJson.store.getMenu().then((response) => {
      if (response.success) {
        setMenuItems(response.data.menu_items);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  const onDeleteMenuItemClicked = (id) => {
    apiJson.store.deleteMenuItem(id).then((response) => {
      if (response.success) {
        setMenuItems(current =>
          current.filter(item => {
            return item.parent_id !== id;
          })
        );
        setMenuItems(current =>
          current.filter(item => {
            return item.id !== id;
          })
        );
        // const index = menu_items.findIndex(item => item.id == id); //use id instead of index
        // if (index > -1) { //make sure you found it
        //  setMenuItems(prevState => prevState.splice(index, 1));
        // }
        message = "Item deleted successfully.";
        showSuccess();
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }

  return (
    <Fragment>
      <div className="vendor-page-right profile-page-desktop">
        <Header heading="Menu Items" search={false} filters={null} />
        <div className="right-content profile-page-content">
          <div className="content-container profile-page-container">
            <div className="content-wrapper menu">
              <div className="header-row d-flex w-100">
                <Link
                  className="btn btn-primary"
                  to="/vendor/menu-item/add"
                >
                  Add Menu Item
                </Link>
              </div>
              <br />
              <div className="card">
                <div className="card-body">
                  <table className="table table-bordered">
                    <tr>
                      <th>ID</th>
                      <th>Name (English)</th>
                      <th>Name (Arabic)</th>
                      {/* <th>Link</th> */}
                      <th>Action</th>
                    </tr>
                    {
                      menu_items?.map((menu_item) => {
                        return (
                          <tr>
                            <td>{menu_item.id}</td>
                            <td>{menu_item.name_en}</td>
                            <td>{menu_item.name_ar}</td>
                            {/* <td>{menu_item.link}</td> */}
                            <td>
                              <Link to={"/vendor/menu-item/edit/" + menu_item.id} className="text-primary">
                                <AiFillEdit />
                              </Link>
                              <Link className="text-danger" onClick={() => onDeleteMenuItemClicked(menu_item.id)}>
                                <AiFillDelete />
                              </Link>
                            </td>
                          </tr>
                        )
                      })
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MenuItems;
